import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Paper, Tab, styled } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { OrganizationForm } from './organization-form'
import { ProfileForm } from './profile-form'
import { BankInfo } from './bank-details/bank-info'
import { DeactivatedUsers } from './deactivated-users'
import { Users } from './users/users'
import { useUserCurrentQuery } from 'services/users'
import { Loading } from 'components/Loading'
import { EOrganizationType } from 'types/users'
import { translate } from 'hoc/Translate'

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  borderRight: '1px solid',
  borderColor: theme.palette.divider,
}))

const tabs = [
  {
    value: '1',
    label: translate('organization'),
    orgType: [EOrganizationType.CLIENT, EOrganizationType.TENDER_AUTHORITY],
  },
  {
    value: '2',
    label: translate('my-profile'),
    orgType: [EOrganizationType.CLIENT, EOrganizationType.TENDER_AUTHORITY],
  },
  {
    value: '3',
    label: translate('bank-info'),
    orgType: [EOrganizationType.TENDER_AUTHORITY],
  },
  {
    value: '4',
    label: translate('users'),
    orgType: [EOrganizationType.TENDER_AUTHORITY],
  },
  {
    value: '5',
    label: translate('deactivated'),
    orgType: [EOrganizationType.TENDER_AUTHORITY],
  },
]

export const Settings: FunctionComponent = () => {
  const { t } = useTranslation()
  const [value, setValue] = useState('1')

  const { data: currentUser, isLoading } = useUserCurrentQuery()

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  if (isLoading) {
    return <Loading fullPage={false} />
  }
  if (currentUser === undefined) {
    return <></>
  }

  return (
    <PageWrapper>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            mt: 2,
          }}
        >
          <TabList
            onChange={handleChange}
            sx={{
              background: 'white',
              width: 'max-content',
              margin: 'auto',
            }}
            centered
          >
            {tabs
              .filter((tab) =>
                tab.orgType.some((type) =>
                  type.includes(currentUser.organizationType)
                )
              )
              .map((tab) => {
                return (
                  <StyledTab key={tab.value} label={tab.label} value={tab.value} />
                )
              })}
          </TabList>
        </Box>
        <Paper
          sx={{
            padding: '20px',
          }}
        >
          <TabPanel value="1">
            <OrganizationForm currentUser={currentUser} />
          </TabPanel>
          <TabPanel value="2">
            <ProfileForm currentUser={currentUser} />
          </TabPanel>
          <TabPanel value="3">
            <BankInfo organizationId={currentUser?.organizationId} />
          </TabPanel>
          <TabPanel value="4">
            <Users organizationId={currentUser?.organizationId} />
          </TabPanel>
          <TabPanel value="5">
            <DeactivatedUsers />
          </TabPanel>
        </Paper>
      </TabContext>
    </PageWrapper>
  )
}
